// all logic for handling variant change, add to cart, subscription selection etc


// handle changing of variants
const variantSelectors = document.querySelectorAll('.variant-picker input');
variantSelectors.forEach(selector => {
    selector.addEventListener('change', function() {

        // get parent form
        const form = this.closest('form');

        // remove checked attribute from current selected, update this one
        const selectedInput = this.closest('.options-flex').querySelector('.variant-picker input[checked]');
        if (selectedInput) {
            selectedInput.removeAttribute('checked');
        }
        this.setAttribute('checked', 'checked');

        // get list user selected options
        let selectedOptions = [];
        const selectedInputs = form.querySelectorAll('.variant-picker input[checked]');
        selectedInputs.forEach(input => selectedOptions.push(input.value)); // get list of selected options
        // find variant by comparing these selected options
        let variantIdInput = form.querySelector('input[id="id"]');
        let productData = JSON.parse(variantIdInput.dataset.product); // get product data
        let selectedVariant = productData.variants.find(variant => { // filter through variants until we find a match

            // create list of options for this variant, where option value isn't null
            let variantOptions = [variant.option1, variant.option2, variant.option3].filter(option => { return option !== null });

            // compare this variant's options, and user's selected options
            if (JSON.stringify(variantOptions) == JSON.stringify(selectedOptions)) {
                return variant;
            }
        });

        // update variant id input
        variantIdInput.setAttribute('value', selectedVariant.id);

        // update buy buttons if in/out of stock
        const addToCartButton = form.querySelector('.add-to-cart');
        const outOfStockButton = form.querySelector('.out-of-stock');
        if (selectedVariant.available) {
            addToCartButton.classList.remove('hide');
            outOfStockButton.classList.add('hide');
        } else {
            addToCartButton.classList.add('hide');
            outOfStockButton.classList.remove('hide');
        }

        // update price - this will be overwritten if subscription selector is withinn the same form
        let prices = form.querySelectorAll('.price');
        prices.forEach(price => {
            price.innerHTML = theme.utils.formatMoney(selectedVariant.price);
        })

        // update price per can if necessary
        let pricePerCanEl = form.querySelector('.price-per-can span');
        if (pricePerCanEl) {
            let totalPrice = selectedVariant.price;
            let packSize = Number(selectedVariant.option1.split(' ')[0]);
            let pricePerCanPence = totalPrice / packSize;
            let formattedPricePerCan = theme.utils.formatMoney(pricePerCanPence);
            pricePerCanEl.innerHTML = formattedPricePerCan;
        }

        // dispatch event so skio updates it's price
        variantIdInput.dispatchEvent( new CustomEvent("variantChanged", { bubbles: true, detail: { variantId: selectedVariant.id } }) );
    });
});

// update product buy buttons if in/out of stock
document.addEventListener('variantChanged', function(e) {
    // console.log(e.detail);
})

// handle changing of subscription selector
let skioContainers = document.querySelectorAll('skio-plan-picker');
skioContainers.forEach(container => {
    container.addEventListener('skio::update-selling-plan', function(event) {

        // everything is handled inside skio-plan-picker-component.js

        // const form = this.closest('form'); // get parent form

        // let addToCartButtonPrice = form.querySelector('.add-to-cart .price');
        // if (addToCartButtonPrice) {
        //     addToCartButtonPrice.innerHTML = event.detail.price;
        // }
    });
});




// Add to cart button logic
let addToCartButtons = document.querySelectorAll('.add-to-cart');

addToCartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
        e.preventDefault();

        // get parent form
        let form = button.closest('form');

        // create form data
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        console.log(data);
        data.quantity = 1;

        // make request to add item to cart
        fetch('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        .then(response => {
            // open cart drawer and update
            const drawer = $('[data-off-canvas--open="right-sidebar"]');
            if (drawer.length > 0) {
                theme.partials.Cart.updateTotals();
                theme.partials.Cart.updateAllHtml(function() {
                    drawer.first().trigger('click');
                });
                theme.partials.Cart.updateAllHasItems(1, true);
                theme.partials.Cart.updateTotals();
                window.setTimeout(() => {drawer.scrollTop = 0}, 200)
            } else {
                window.location.href = '/cart';
            }
        });

    })
})